export default __webpack_public_path__ + "static/media/w.fd217510.svg";